import { Icon } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { track, events } from 'src/configs/amplitude';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import SplitPageContainer from 'src/components/shared/SplitPageContainer';
import LoginLeftContent from 'src/components/shared/LoginLeftContent';
import doneSvg from 'src/img/done.svg';
import useStyles from './styles';
export default function ResetPasswordSuccessPage() {
  const classes = useStyles();
  const page = 'Password Success';
  return /*#__PURE__*/React.createElement(SplitPageContainer, {
    imageScr: doneSvg,
    largeTopMargin: true,
    leftBlock: /*#__PURE__*/React.createElement(LoginLeftContent, null)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.pageForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.resetPageSuccessIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    marginBottom: "40px"
  }, "New password set."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    marginBottom: "40px"
  }, "Your new password has been successfully saved. Now you can use it to log in."), /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    component: RouterLink,
    to: "/login",
    onClick: () => track(events.clicked('Back To Login'), {
      page
    }),
    fullWidth: true,
    'custom-attribute': '809-reset-password-success-page'
  }, "Log into Manager portal")));
}
ResetPasswordSuccessPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};